define('taoQtiItem/qtiItem/core/choices/SimpleAssociableChoice',['taoQtiItem/qtiItem/core/choices/ContainerChoice'], function(QtiContainerChoice){

    var QtiSimpleAssociableChoice = QtiContainerChoice.extend({
        qtiClass : 'simpleAssociableChoice'
    });
    
    return QtiSimpleAssociableChoice;
});



